export const legacyVisitStatusRows = [
  { category: '유입경로', visit: 'Mock 온라인 검색', counts: { '2026-06': 4, '2026-07': 6, '2026-08': 5 } },
  { category: '유입경로', visit: 'Mock 지인 소개', counts: { '2026-06': 2, '2026-07': 3, '2026-08': 4 } },
  { category: '유입경로', visit: 'Mock 제휴 채널', counts: { '2026-06': 1, '2026-07': 2, '2026-08': 2 } },
]

export const legacyVisitGroups = ['Mock 그룹 A', 'Mock 그룹 B']
export const legacyVisitMotives = ['Mock 온라인 검색', 'Mock 지인 소개', 'Mock 제휴 채널']
